import styled from '@emotion/styled';
import { body02, headline03 } from '@/components/pages/about/styles/typography';
import { breakpointMedium } from '@/constants/breakpoints';
import { colors } from '@/constants/colors';

const SectionContainer = styled.section`
display: flex;
width: 100%;
flex-direction: column;
align-items: center;
`;

const SectionInner = styled.div`
width: 100%;
max-width: 1200px;
padding: 0 16px;

@media (max-width: ${breakpointMedium}) {
  padding: 0 20px;
}
`;

const SectionHgroup = styled.hgroup`
display: flex;
width: 100%;
flex-direction: column;
align-items: center;
gap: 16px;

@media (max-width: ${breakpointMedium}) {
  gap: 8px;
}
`;

const SectionTitle = styled.h2`
  ${headline03}

  color: ${colors.textPrimary};
  text-align: center;
`;

const SectionSubtitle = styled.p`
  ${body02}

  color: ${colors.textBody};
  text-align: center;
`;

const SectionList = styled.ul`
  display: flex;
  width: 100%;
  flex-direction: column;
  align-items: center;
  padding: 0;
  margin: 0;
  list-style: none;
`;

export const Section = {
  Container: SectionContainer,
  Inner: SectionInner,
  Hgroup: SectionHgroup,
  Title: SectionTitle,
  Subtitle: SectionSubtitle,
  List: SectionList,
};
